import { IVendorInitialState } from "../../../types/master/vendorInterface";
import { VendorActionTypes, VendorActions } from "../../actionTypes/master/vendorActionTypes";


const initialState: IVendorInitialState = {
  vendorList: [],
  vendorData: {
    id: 0,
    address: "",
    name: "",
    vendor_code: "",
    email: "",
    contact_number: "",
    our_company_id: 0,
    tds_rate: 0,
    profile_status: "",
    is_gst_applicable: 0,
    gstin: "",
    gst_rate: 0,
    contact_person:"",
    internal_code:"",
  },
  vendorListPageCount: 0,
};

export default function vendorReducer(state = initialState, action: VendorActionTypes): IVendorInitialState {
  switch (action.type) {

    case VendorActions.SET_VENDOR_LIST:
      return {
        ...state,
        vendorList: action.payload    
      };

    case VendorActions.SET_VENDOR_LIST_PAGE_COUNT:
      return {
        ...state,
        vendorListPageCount: action.payload
      };

    case VendorActions.SET_VENDOR_DATA_BY_ID:
      return {
        ...state,
        vendorData: action.payload
      }

    default:
      return state;
  }
}
